import { render, staticRenderFns } from "./SidebarVideoDatabase.vue?vue&type=template&id=815c24ac&scoped=true"
import script from "./SidebarVideoDatabase.vue?vue&type=script&lang=js"
export * from "./SidebarVideoDatabase.vue?vue&type=script&lang=js"
import style0 from "./SidebarVideoDatabase.vue?vue&type=style&index=0&id=815c24ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815c24ac",
  null
  
)

export default component.exports